import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

//
import IMG1 from "../../../assets/images/about-us-right.jpg";
import IMG2 from "../../../assets/images/about-us-right.jpg";
import IMG3 from "../../../assets/images/about-us-right.jpg";
import IMG4 from "../../../assets/images/about-us-right.jpg";
import IMG5 from "../../../assets/images/about-us-right.jpg";
import IMG6 from "../../../assets/images/about-us-right.jpg";
import IMG7 from "../../../assets/images/about-us-right.jpg";

export default function AboutGallery() {
  const { t } = useTranslation();

  return (
    <StyledAboutGallery>
      <div className="container">
        <div className="about-galery__wrap">
          <h1 className="about-galery__title">{t("aboutGalleryTitle")}</h1>
          <ul className="about-galery__list">
            <li className="">
              <img src={IMG1} alt="IMG1" />
            </li>
            <li>
              <img src={IMG2} alt="IMG1" />
            </li>
            <li>
              <img src={IMG3} alt="IMG1" />
            </li>
            <li>
              <img src={IMG4} alt="IMG1" />
            </li>
            <li>
              <img src={IMG5} alt="IMG1" />
            </li>
            <li>
              <img src={IMG6} alt="IMG1" />
            </li>
            <li>
              <img src={IMG7} alt="IMG1" />
            </li>
          </ul>
        </div>
      </div>
    </StyledAboutGallery>
  );
}

const StyledAboutGallery = styled.section`
  background-color: var(--white);
  padding: 140px 0;

  .about-galery {
    &__wrap {
    }

    &__title {
      color: var(--title);
      font-size: var(--fs-section-title);
      font-style: normal;
      font-weight: var(--fw-semibold);
      line-height: var(--lh-title);
      margin-bottom: 32px;
    }

    &__list {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 24px;

      li {
        line-height: 0;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: 0.4s ease;
          border: 1px solid var(--border);
        }

        &:hover {
          img {
            transform: scale(1.125);
          }
        }

        &:nth-child(1) {
          grid-column: 1 / 5;
        }

        &:nth-child(2) {
          grid-column: 5 / 6;
        }

        &:nth-child(3) {
          grid-column: 1 / 4;
        }

        &:nth-child(4) {
          grid-column: 4 / 6;
        }

        &:nth-child(5) {
          grid-column: 1 / 6;
        }

        &:nth-child(6) {
          grid-column: 1 / 3;
        }

        &:nth-child(7) {
          grid-column: 3 / 6;
        }
      }
    }
  }
`;
